export default "__VITE_ASSET__DwV1Zxj0__"